import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export const LoadingWithLabel = (props) => {
	return (
		<Backdrop
			sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={true}
		>
			<Box sx={{ position: "relative", display: "inline-flex" }}>
				<CircularProgress
					sx={{
						color: "#B2FE1C",
					}}
					size={120}
					{...props}
				/>
				<Box
					sx={{
						top: 0,
						left: 0,
						bottom: 0,
						right: 0,
						position: "absolute",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<Typography
						variant="caption"
						component="div"
						color="text.secondary"
					>{`${Math.round(props.value)}%`}</Typography>
				</Box>
			</Box>
		</Backdrop>
	);
};

export const Loading = (props) => {
	return (
		<Backdrop
			sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={true}
		>
			<CircularProgress sx={{ color: "#B2FE1C" }} size={80} {...props} />
		</Backdrop>
	);
};
